// src/services/storage/ImageStorageService.js

class ImageStorageService {
  constructor() {
    this.captures = [];
  }

  addCapture(captureData) {
    const entry = {
      index: captureData.index,
      filename: captureData.filename,
      description: captureData.description || '',
      timestamp: captureData.timestamp
    };

    const existingIndex = this.captures.findIndex(c => c.filename === entry.filename);
    if (existingIndex >= 0) {
      this.captures[existingIndex] = entry;
    } else {
      this.captures.push(entry);
    }

    this.captures.sort((a, b) => a.index - b.index);

    return entry;
  }

  getCaptures() {
    return [...this.captures];
  }

  clearCaptures() {
    this.captures = [];
  }

  downloadImage(imageData, filename) {
    const link = document.createElement('a');
    link.href = imageData;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  generateCSV() {
    if (this.captures.length === 0) {
      return null;
    }

    const rows = this.captures.map(capture => {
      const escapedDesc = (capture.description || '').replace(/"/g, '""');
      return `${capture.index},"${escapedDesc}"`;
    });

    return rows.join('\n');
  }

  downloadCSV(filename = 'captures.csv') {
    const csvContent = this.generateCSV();
    
    if (!csvContent) {
      return false;
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    return true;
  }
}

export default new ImageStorageService();